import { Svg } from 'common/assets'
import { useTranslation } from 'react-i18next'
import { Container, FlexWrapperUpButton, Icon, Text } from './styled'

export const UpButton = () => {
  const { t } = useTranslation()

  const onUpButton = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <>
      <FlexWrapperUpButton>
        <Container onClick={onUpButton}>
          <Icon src={Svg.ArrowDown} />
          <Text>{t('up')}</Text>
        </Container>
      </FlexWrapperUpButton>
    </>
  )
}
